import { call, put, take, select, fork, cancel, cancelled } from 'redux-saga/effects'
import { eventChannel } from 'redux-saga'
import firebase from 'firebase/app'

import CashOutActions, { CashOutTypes } from '../reducers/cashOutReducer'

export function* getHistoryCashOuts({ from, to }) {
  try {
    const cashOutsRef = firebase
      .firestore()
      .collection('cash_out_requests')
      .where('created_at', '>=', from)
      .where('created_at', '<=', to)
      .orderBy('created_at')

    const cashOutsSnapshot = yield call([cashOutsRef, cashOutsRef.get])
    const cashOuts = []

    cashOutsSnapshot.forEach(doc => {
      const cashOut = doc.data()

      if (cashOut.status !== 'pending') {
        cashOuts.push({ ...cashOut, id: doc.id })
      }
    })

    yield put(CashOutActions.setHistoryCashOuts(cashOuts))
  } catch (e) {
    yield put(CashOutActions.setCashOutsLoading(false))
  }
}

export function* confirmCashOut({ requestId, callback }) {
  try {
    const { username } = yield select(state => state.auth.data)

    const params = {
      requestId,
      handler: username,
    }

    const functions = firebase
      .app()
      .functions('asia-northeast1')
      .httpsCallable('confirmDriverCashOut')

    yield call(functions, params)
    callback(null)
  } catch (e) {
    callback(e)
  }
}

export function* cancelCashOut({ requestId, reason, callback }) {
  try {
    const { username } = yield select(state => state.auth.data)

    const params = {
      requestId,
      handler: username,
      reason,
    }

    const functions = firebase
      .app()
      .functions('asia-northeast1')
      .httpsCallable('cancelDriverCashOut')

    yield call(functions, params)
    callback(null)
  } catch (e) {
    callback(e)
  }
}

const observer = ref => {
  const listener = eventChannel(emit => {
    const subscriber = ref.onSnapshot(
      querySnapshot => {
        const cashOuts = []

        querySnapshot.forEach(doc => {
          cashOuts.push({ ...doc.data(), id: doc.id })
        })

        emit(cashOuts)
      },
      err => {
        emit(new Error(err))
      }
    )

    return () => subscriber
  })
  return listener
}

export function* cashOutsObserver() {
  const ref = firebase
    .firestore()
    .collection('cash_out_requests')
    .where('status', '==', 'pending')

  const channel = yield call(observer, ref)
  try {
    while (true) {
      const snapshot = yield take(channel)

      yield put(CashOutActions.setPendingCashOuts(snapshot))
    }
  } catch (err) {
    yield put(CashOutActions.setCashOutsLoading(false))
  } finally {
    if (yield cancelled()) {
      channel.close()
    }
  }
}

export function* syncPendingCashOuts() {
  const cashOutsListener = yield fork(cashOutsObserver)

  yield take(CashOutTypes.UN_SYNC_PENDING_CASH_OUTS)
  yield cancel(cashOutsListener)
}



// WEBPACK FOOTER //
// ./src/sagas/cashOutSaga.js